import isString from 'lodash/isString';
import { exception } from '@/exceptions/Exceptions';

/**
 * Format postcode.
 *
 * @param {String} postcode
 *
 * @returns {String}
 *
 * @throws {Error}
 */
export const formatPostcode = (postcode) => {
    if (!isPostcodeFormatValid(postcode)) exception('Invalid Postcode.');

    let postcodeRegEx = /(^[A-Z]{1,2}[0-9]{1,2}[A-Z]{0,1})([0-9][A-Z]{2}$)/i;

    return postcode.replace(postcodeRegEx, '$1 $2').toUpperCase();
};

/**
 * Check if postcode pattern is valid format.
 *
 * @todo Check VUE_APP_COUNTRY_ISO to dynamically change the postcode regex pattern.
 *
 * @param {String} postcode
 *
 * @returns {Boolean}
 */
export const isPostcodeFormatValid = (postcode) => {
    if (!postcode || !isString(postcode)) return false;

    let postcodeRegEx = /^[A-Z]{1,2}[0-9]{1,2}[A-Z]{0,1} *[0-9][A-Z]{2}$/i;

    return postcodeRegEx.test(postcode);
};
